import React, {useEffect, useState} from "react";
import "./member.css";
import {dateTimeFormat} from "../../services/misc.functions";
import {ApiService} from "lib/http.service";
import {env} from "../../constants/global.vars";
import NumericTickets from "../games/numericgames/NumericTickets";

const statusMap: any = {
    0: {label: "Beklemede", className: "bg-warning text-dark"},
    1: {label: "Çekiliş Bekleyen", className: "bg-primary"},
    2: {label: "Kazandı", className: "bg-success"},
    3: {label: "Kaybetti", className: "bg-danger"},
    4: {label: "İptal", className: "bg-secondary"},
    5: {label: "Oynama Hatası", className: "bg-dark"},
    6: {label: "İade", className: "bg-info text-dark"},
    7: {label: "Hazır Kupon", className: "bg-light text-dark"}
}

export function MemberNumericTickets() {
    const [tabs, setTabs] = useState([{value: "tümü", label: "Tümü", content: <VirtualTickets code={null}/>}]);
    const [selectedTab, setSelectedTab] = useState(tabs[0]);

    const handleSelect = (e: any) => {
        if (e.target.id) {
            setSelectedTab(tabs[e.target.id]);
        }
    };

    return (
        <>
            <h1>Sayısal Oyun Biletlerim</h1>
            <div className="page-widget">
                <svg style={{display: "none"}}>
                    <defs>
                        <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"></path>
                    </defs>
                </svg>

                <div className={"tab-scroll"}>
                    <ul className="nav nav-tabs">
                        {tabs.map(({value, label}: { value: string; label: string }, index) => {
                            return (
                                <li
                                    key={`tabs-index-${index}`}
                                    className={`nav-item ${selectedTab.value === value ? "active" : ""}`}
                                    onClick={handleSelect}
                                >
                                    <svg className="left" viewBox="0 0 80 60" preserveAspectRatio="none">
                                        <use xlinkHref="#tabshape"></use>
                                    </svg>
                                    <a className="nav-link" id={`${index}`}>
                                        {label.toUpperCase()}
                                    </a>
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none">
                                        <use xlinkHref="#tabshape"></use>
                                    </svg>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                <div className="p-1 p-lg-3">{selectedTab.content}</div>
            </div>
        </>
    );
}

function VirtualTickets({code}: { code: string | null }) {
    const [tickets, setTickets] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [pagination, setPagination] = useState({total_page: 0, current_page: 0});
    const [selectedTicket, setSelectedTicket] = useState<any>(null);
    const [serverTime, setServerTime] = useState<any>(null);

    useEffect(() => {
        setTickets([]);
        loadData(0, true);
    }, [code]);

    const loadData = (pageNum: number, isFirstLoad: boolean = false) => {
        setLoading(true);
        let api = new ApiService();
        api.start("post", env.accounting_api + "/games/api/list-coupon/", {
            vendor: 7,
            detail: true,
            page: pageNum,
            game_id: code
        }, true)
            .then((res: any) => {
                const newTickets = res.data || [];
                const meta = res.metadata;
                setServerTime(new Date(meta.timestamp).getTime());

                if (isFirstLoad) setTickets(newTickets);
                else setTickets(prev => [...prev, ...newTickets]);

                if (meta) {
                    setPagination({total_page: meta.total_page, current_page: meta.page});
                    setPage(meta.page);
                }
            })
            .finally(() => setLoading(false));
    };

    return (
        <div className="table-responsive">
            <table className="table table-borderless betting-table ticket-table custom-theme-table">
                <thead>
                <tr>
                    <th>Bilet No</th>
                    <th>Oyun</th>
                    <th>İşlem Tarihi</th>
                    <th>Miktar</th>
                    <th>Durum</th>
                </tr>
                </thead>
                <tbody>
                {tickets.map((ticket: any, index: number) => {
                    const isEventStarted = serverTime > ticket.coupon_detail.eventDate ;
                    const isWaitingDrawResult = ticket.status === 1 && isEventStarted;
                    return <tr
                        key={`${ticket.transaction_id}-${index}`}
                        onClick={() => {
                            if (ticket.status === 4) return;
                            setSelectedTicket(ticket)
                        }}
                        style={{cursor: 'pointer'}}
                        className="border-bottom"
                    >
                        <td>
                            <div className="p-2">
                                <span className="game-name fw-bold">{ticket.transaction_id}</span>
                            </div>
                        </td>
                        <td>{ticket.game__name}</td>
                        <td>{dateTimeFormat(ticket.transaction_date)}</td>
                        <td>{ticket.amount} ₺</td>
                        <td>
                                <span className={`badge ${statusMap[ticket.status]?.className || 'bg-secondary'}`}>
                                    {isWaitingDrawResult ?  'Çekiliş Sonuçları Bekleniyor' : statusMap[ticket.status]?.label || 'Bilinmeyen'}
                                </span>
                        </td>
                    </tr>
                })}
                </tbody>
            </table>

            {selectedTicket && (
                <div
                    className="modal-open"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    onClick={() => setSelectedTicket(null)}
                >
                    <div
                        style={{
                            backgroundColor: '#fff',
                            borderRadius: '8px',
                            width: '100%',
                            height: '100%',
                            maxWidth: '600px',
                            maxHeight: '90vh',
                            overflowY: 'auto',
                            position: 'relative',
                            display: 'flex',
                            flexDirection: 'column',
                            boxShadow: '0 5px 15px rgba(0,0,0,0.5)',
                        }}
                        onClick={e => e.stopPropagation()}
                    >
                        <NumericTickets ticketId={selectedTicket.transaction_id} gameSlug={selectedTicket.game__code}
                                        onClose={() => setSelectedTicket(null)}/>
                    </div>
                </div>
            )}

            <div className="text-center mt-4 mb-5">
                {loading ? (
                    <div className="spinner-border text-primary" role="status"></div>
                ) : (
                    pagination.current_page < pagination.total_page && (
                        <button className="btn btn-primary btn-md px-5" onClick={() => loadData(page + 1)}>
                            Daha Fazla Yükle
                        </button>
                    )
                )}
            </div>
        </div>
    );
}